export default __webpack_public_path__ + "static/media/payment_success.f6ae0231.svg";